import React, { useEffect, useState } from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const STORAGE_KEY = 'loksy_cookie_consent_v1';

/**
 * Lightweight necessary-cookies notice. Does not block Google Sign-In / auth.
 */
export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      role="dialog"
      aria-label="Cookie notice"
      sx={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 1400,
        maxWidth: 560,
        mx: 'auto',
        p: 2,
        borderRadius: 2,
        bgcolor: '#0F172A',
        color: 'rgba(255,255,255,0.92)',
        boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 1.5,
        alignItems: { sm: 'center' },
      }}
    >
      <Typography variant="body2" sx={{ flex: 1, lineHeight: 1.5, opacity: 0.9 }}>
        Loksy uses necessary cookies for login and security. Optional analytics are off by default.
        See our{' '}
        <Link component={RouterLink} to="/cookie-policy" sx={{ color: '#93C5FD' }}>
          Cookie Policy
        </Link>
        .
      </Typography>
      <Button
        variant="contained"
        size="small"
        onClick={accept}
        sx={{ textTransform: 'none', fontWeight: 700, flexShrink: 0 }}
      >
        Got it
      </Button>
    </Box>
  );
}
